import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState, FrameReturnsActionTypes } from '@app/core/ngrx';

@Component({
  selector: 'ecp-returns-frame-detail',
  templateUrl: './returns-frame-details.component.html',
  styleUrls: ['./returns-frame-details.component.scss'],
})
export class ReturnsFrameDetailsComponent {
  @Input() frames;
  displayPrescription = false;

  constructor(public store: Store<AppState>) {}
  togglePrescription() {
    this.displayPrescription = !this.displayPrescription;
  }

  removeFrame(index) {
    this.store.dispatch({
      type: FrameReturnsActionTypes.REMOVE_FRAME_FROM_RETURNS,
      payload: index,
    });
  }
}
